import React, { useContext, useEffect, useState } from 'react';
import { Form, Media } from 'react-bootstrap';
import UserAvatar from '../../components/UserAvatar';
import Layout from "../../components/Layout";
import { callAPI } from "../../helper/apiUtils";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import { BASE_URL } from "../../helper/constants";
import { Link } from "react-router-dom";
import { convertBranchRole } from '../../helper/convertor';
import { Scrollbars } from "react-custom-scrollbars";
import "./UserFollowers.css";
const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return (
    <div
      className="thumb-style"
      style={{ ...style, ...thumbStyle }}
      {...props}
    />
  );
};
const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);
function Followers(props) {
  const { isGerm, strings } = useContext(LanguageContext)
  const [followers, setFollowers] = useState([])
  const [allFollowers, setAllFollowers] = useState([])
  const [search, setSearch] = useState("")
  const getFollowers = async () => {
    const id = props.match.params.id
    const { data } = await callAPI(`/user/${id}/follower`, {}, 'GET')
    console.log(data)
    setAllFollowers(data.followers)
    setFollowers(data.followers)
  }
  useEffect(() => {
    getFollowers();
  }, [])
  const backToUrl = () => {
    window.history.go(-1);
    return false;
  }
  const searchFollowers = async (value) => {
    setSearch(value);
    const searchResult = await allFollowers.filter((itm) => {
      if (value === "") {
        return itm;
      } else if (itm.firstName?.toLowerCase().startsWith(value?.toLowerCase()) || itm.lastName?.toLowerCase().startsWith(value?.toLowerCase())) {
        return itm;
      }
    });
    if (value === "") {
      setFollowers(allFollowers);
    } else {
      setFollowers(searchResult);
    }
  };
  return (
    <React.Fragment>
      {
        followers &&
        <div class="following follower user-followers">
          <div className="main_heading">
            <span 
              className="material-symbols-outlined material-arrow-left pointer user-followers__back user-followers__back--clickable"
              onClick={backToUrl}
            >
              keyboard_arrow_left
            </span>
            {strings.followers}
          </div>
          <div className="search user-followers__search">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Control
                autocomplete="off"
                onChange={(e) => searchFollowers(e.target.value)}
                value={search}
                type="search"
                placeholder={strings.search}
              />
            </Form.Group>
          </div>
          <div className="my-scroll user-followers__scroll">
            <CustomScrollbars
              autoHide
              autoHideTimeout={500}
              autoHideDuration={200}
              className="bottom-bar"
            >
              {
                followers &&
                followers.map(follower => (
                  <div key={follower.id} className="post_notification">
                    <div className="my_post">
                      <Media>
                        <UserAvatar
                          width={30}
                          height={30}
                          className="mr-3"
                          src={follower.avatar ? BASE_URL + follower.avatar : process.env.PUBLIC_URL + "/assets/img/head.svg"}
                          alt="User avatar"
                          fallbackSrc={process.env.PUBLIC_URL + "/assets/img/head.svg"}
                          isKjuup={follower.isKjuup || follower.companies?.some(c => c.isKjuup)}
                        />
                        <Media.Body>
                          <div className="authore_name">
                            <Link to={`/user-profile/${follower.id}`}><h5>{follower.fullName}</h5></Link>
                            <p>{follower.buildingIndustryRole?.split(",").map((itm, index) => (index ? ", " : "") + convertBranchRole(itm, isGerm))}</p>
                          </div>
                        </Media.Body>
                      </Media>
                    </div>
                  </div>
                ))

              }
            </CustomScrollbars>
          </div>
        </div>
      }
      {
        !followers &&
        <div class="following follower">
          <div className="main_heading">
            <span 
              className="material-symbols-outlined material-arrow-left user-followers__back"
            >
              keyboard_arrow_left
            </span>
            {strings.followers}
          </div>
        </div>
      }
    </React.Fragment>
  );
}

export default Followers;